import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import { useNewsletter } from "@/store/newsletter.composable";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterModal',
  setup(__props) {

const footer = computed<Vertica.LouisPoulsen.Application.Navigation.ViewModels.FooterViewModel>(() => store.getters["app/footer"]);
const isNewsletterModalOpen = computed<boolean>(() => store.getters["navigation/isNewsletterModalOpen"]);

const { setPrefilledNewsletterSignupInformation } = useNewsletter();

function toggleNewsletterModal() {
    store.dispatch("navigation/toggleNewsletterModal");
}

const formSubmitted = ref<boolean>(false);

function onSubmit() {
    formSubmitted.value = true;
}

function closePopup() {
    if (formSubmitted.value) {
        setTimeout(() => {
            formSubmitted.value = false;
        }, 500); // Align with CSS animation
    }
    toggleNewsletterModal();
    setPrefilledNewsletterSignupInformation(null);
}

return { __sfc: true,footer, isNewsletterModalOpen, setPrefilledNewsletterSignupInformation, toggleNewsletterModal, formSubmitted, onSubmit, closePopup }
}

})